// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3M9l0","emails":"CreateEditClinics_emails__1Kfnu","emailTagLabel":"CreateEditClinics_emailTagLabel__1H0Te"};